export const deletionRequestsEn = {
  // Direct translations for deletion types and statuses
  USER_ACCOUNT: 'User Account',
  TENANT_COMPANY: 'Company',

  // Status translations
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  FAILED: 'Failed',

  // Common translations
  common: {
    cancel: 'Cancel'
  },

  // Pages structure for settings
  pages: {
    settings: {
      deletionRequests: {
        title: 'Account Deletion',
        description: 'Manage your account deletion requests and understand our data retention policy. All deletion requests have a 30-day processing period during which you can cancel the request.',
        deleteAccount: {
          title: 'Delete Account',
          description: 'Submit a request to delete your account and all associated data after a 30-day processing period.',
          warning: 'After submission, there is a 30-day processing period before any data is deleted. You can cancel the request during this time.',
          activeRequestWarning: 'You already have an active deletion request. Please wait for it to be processed.',
          button: 'Delete Account'
        },
        existingRequests: {
          title: 'Your Deletion Requests',
          loading: 'Loading deletion requests...',
          empty: 'No deletion requests found',
          accountDeletion: 'Account Deletion Request',
          requestedAt: 'Requested',
          completedAt: 'Completed',
          type: 'Type',
          verified: 'Identity Verified',
          yes: 'Yes',
          no: 'No',
          cancel: 'Cancel Request'
        },
        status: {
          PENDING_VERIFICATION: 'Pending Verification',
          VERIFIED: 'Verified',
          IN_PROGRESS: 'In Progress',
          COMPLETED: 'Completed',
          REJECTED: 'Rejected',
          CANCELLED: 'Cancelled',
          pending: 'Pending',
          processing: 'Processing',
          completed: 'Completed',
          failed: 'Failed'
        },
        types: {
          user_account: 'User Account',
          tenant_company: 'Company'
        }
      }
    }
  },

  // Modal translations
  modals: {
    deleteAccount: {
      title: 'Delete Account',
      warning: 'This will submit a deletion request that begins a 30-day processing period.',
      irreversible: 'Nothing is deleted immediately. You have 30 days to cancel this request before data deletion begins.',
      processingInfo: {
        title: 'Deletion Process Information',
        period: '30-day processing period begins after submission',
        cancellation: 'You can cancel the request anytime during the 30-day period',
        finalDeletion: 'After 30 days, data will be permanently deleted'
      },
      dataInfo: {
        title: 'What will happen to your data?',
        deletedAfter30Days: 'Data deleted after 30-day processing period:',
        retainedPseudonymized: 'Data retained (pseudonymized) for legal compliance:',
        deletedAfter30DaysItems: {
          personalInfo: 'Name, email, phone, address',
          cvAttachments: 'CV and attachments',
          notesRatings: 'Notes and ratings',
          profileData: 'Profile data'
        },
        retainedItems: {
          applicationData: 'Application dates and positions',
          auditLogs: 'Audit logs',
          consentRecords: 'Consent records',
          technicalLogs: 'IP addresses and technical logs',
          period6months: '6 months',
          period12months: '12 months',
          period24months: '24 months'
        }
      },
      reason: {
        label: 'Reason for deletion (optional)',
        placeholder: 'Tell us why you\'re deleting your account...',
        hint: 'This helps us improve our service'
      },
      password: {
        label: 'Confirm your password',
        placeholder: 'Enter your current password',
        hint: 'Required to verify your identity'
      },
      confirmation: {
        instruction: 'Type \'DELETE\' in capital letters to confirm:',
        label: 'Confirmation',
        valid: 'Confirmation text is correct',
        invalid: 'Please type \'DELETE\' exactly as shown'
      },
      finalConfirmation: 'I understand that this will start a 30-day processing period and I can cancel the request during this time',
      deleteButton: 'Delete My Account'
    },
    deleteCompany: {
      title: 'Delete Company',
      warning: 'This will submit a deletion request for your entire company that begins a 30-day processing period.',
      irreversible: 'Nothing is deleted immediately. You have 30 days to cancel this request before company data deletion begins.',
      dataInfo: {
        title: 'What will happen to your company data?',
        deletedAfter30Days: 'Company data deleted after 30-day processing period:',
        retainedPseudonymized: 'Data retained (pseudonymized) for legal compliance:'
      },
      reason: {
        label: 'Reason for company deletion (optional)',
        placeholder: 'Tell us why you\'re deleting the company...',
        hint: 'This helps us improve our service'
      },
      password: {
        label: 'Confirm your password',
        placeholder: 'Enter your current password',
        hint: 'Required to verify your admin identity'
      },
      confirmation: {
        instruction: 'Type \'DELETE COMPANY\' in capital letters to confirm:',
        label: 'Confirmation',
        valid: 'Confirmation text is correct',
        invalid: 'Please type \'DELETE COMPANY\' exactly as shown'
      },
      finalConfirmation: 'I understand that this will start a 30-day processing period and I can cancel the request during this time',
      deleteButton: 'Delete Company'
    }
  }
};